import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { ParamDescriptorWrapper } from 'developer-docs-shared-components/modules/ParamForm/components/fields/shared/Helpers';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const typeToSchemaTypeI18nKey = {
  string: 'developer-docs-shared-components.params.body.types.string',
  'list(long)': 'developer-docs-shared-components.params.body.types.listOfLong',
  list: 'developer-docs-shared-components.params.body.types.list',
  long: 'developer-docs-shared-components.params.body.types.long',
  boolean: 'developer-docs-shared-components.params.body.types.boolean',
  file: 'developer-docs-shared-components.params.body.types.file',
  jsonString: 'developer-docs-shared-components.params.body.types.jsonString',
  integer: 'developer-docs-shared-components.params.body.types.integer'
};
const EndpointParameter = props => {
  const {
    name,
    required
  } = props;
  const typeI18nKey = props.schemaGroup && props.type && typeToSchemaTypeI18nKey[props.type];
  return /*#__PURE__*/_jsxs(Flex, {
    flexWrap: "nowrap",
    children: [/*#__PURE__*/_jsx(ParamDescriptorWrapper, {
      children: /*#__PURE__*/_jsxs("div", {
        style: {
          wordBreak: 'break-word'
        },
        className: "params-descriptor",
        children: [/*#__PURE__*/_jsxs(Text, {
          typography: "heading-50",
          paddingBlockStart: "100",
          as: "strong",
          children: [name, required ? '*' : '']
        }), typeI18nKey && /*#__PURE__*/_jsx(Text, {
          typography: "detail-200",
          color: "text-primary-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: typeI18nKey
          })
        }), /*#__PURE__*/_jsx(Text, {
          typography: "detail-200",
          color: "text-primary-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `developer-docs-shared-components.params.body.schemaGroup.${props.schemaGroup || props.type}Params`
          })
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "params-content",
      children: /*#__PURE__*/_jsx("div", {
        children: props.children
      })
    })]
  });
};
export default EndpointParameter;